import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import DataTable from '../../components/DataTable';
import ModalShell from '../../components/ModalShell';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

function LaundryFormModal({ kayit, onKapat, onKaydet, kaydediliyor, hata }) {
  const yeni = !kayit?.laundryId;
  const [form, setForm] = useState({
    ad: kayit?.ad ?? '',
    fiyat: kayit?.fiyat ?? 0,
    grup: kayit?.grup ?? 'YIKAMA',
    aktifMi: kayit?.aktifMi ?? true
  });
  const [hatalar, setHatalar] = useState({});

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${
      hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-sky-400 focus:ring-4 focus:ring-sky-50 shadow-sm'
    }`;

  const set = (k, v) => { setForm(p => ({ ...p, [k]: v })); setHatalar(p => ({ ...p, [k]: null })); };

  async function handleKaydet() {
    if (!form.ad.trim()) { setHatalar({ ad: 'Hizmet adı zorunludur.' }); return; }
    onKaydet({ ...(kayit?.laundryId ? { laundryId: kayit.laundryId } : {}), ...form, ad: form.ad.toUpperCase() });
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-0 lg:p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none font-sans">
      <div className="bg-white w-full max-w-xl rounded-none lg:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden border border-white/20 animate-scale-in">
        {/* Modal Header */}
        <div className="relative flex items-center justify-between px-8 py-7 bg-gradient-to-r from-sky-500 to-blue-700 overflow-hidden text-left leading-none">
          <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none transform-gpu"></div>
          <div className="relative flex items-center gap-4 leading-none">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-2xl shadow-inner border border-white/30 font-black leading-none">🧺</div>
            <div className="leading-none">
              <h2 className="text-white font-black text-lg tracking-tight uppercase leading-none">{yeni ? 'Yeni Laundry Hizmeti' : 'Hizmeti Düzenle'}</h2>
              <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest mt-1.5 opacity-80 leading-none">Yıkama, ütüleme ve terzi tanımları</p>
            </div>
          </div>
          <button onClick={onKapat} className="relative z-10 text-white/60 hover:text-white w-10 h-10 flex items-center justify-center rounded-xl hover:bg-white/10 transition-all text-xl leading-none">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-6 no-scrollbar leading-none text-left">
          {(hata || hatalar.genel) && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata || hatalar.genel}</div>}

          <div className="text-left">
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">HİZMET ADI *</label>
            <input value={form.ad} onChange={e => set('ad', e.target.value.toUpperCase())} className={INP(hatalar.ad)} placeholder="ÖRN: TAKIM ELBİSE, GÖMLEK..." autoFocus />
            <FormHata mesaj={hatalar.ad} />
          </div>

          <div className="grid grid-cols-2 gap-6 leading-none text-left">
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">BİRİM FİYAT (₺)</label>
              <div className="relative">
                <input type="number" step="0.01" value={form.fiyat} onChange={e => set('fiyat', parseFloat(e.target.value) || 0)} className={INP(false) + ' pr-12 text-center text-lg'} />
                <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">₺</span>
              </div>
            </div>
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">HİZMET GRUBU</label>
              <select value={form.grup} onChange={e => set('grup', e.target.value)} className={INP(false) + ' cursor-pointer'}>
                {['YIKAMA', 'ÜTÜLEME', 'KURU TEMİZLEME', 'TERZİ'].map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
          </div>

          <div className="pt-4">
             <label className="flex items-center justify-between bg-gray-50/50 p-4 rounded-2xl border-2 border-gray-100 shadow-inner group select-none cursor-pointer leading-none">
                <span className={`text-[10px] font-black uppercase tracking-widest transition-colors duration-300 ${form.aktifMi ? 'text-sky-600' : 'text-gray-400'}`}>HİZMET SATIŞA AÇIK (AKTİF)</span>
                <div className="relative leading-none">
                  <input type="checkbox" checked={form.aktifMi} onChange={e => set('aktifMi', e.target.checked)} className="sr-only peer" />
                  <div className="w-12 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-sky-600 shadow-sm transform-gpu"></div>
                </div>
             </label>
          </div>
        </div>

        <div className="px-8 py-6 flex gap-4 justify-end border-t border-gray-50 bg-gray-50/50 leading-none">
          <button onClick={onKapat} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-sky-500 to-blue-700 hover:from-sky-600 hover:to-blue-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-sky-100 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase leading-none">
            {kaydediliyor ? '⌛ KAYIT...' : '💾 HİZMETİ KAYDET'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function LaundryTanimlari() {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [arama, setArama] = useState('');
  const [hata, setHata] = useState(null);
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const veriYukle = useCallback(async () => {
    setYukleniyor(true);
    try { setListe((await apiRequest('laundry')) || []); } catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  async function handleKaydet(data) {
    setKaydediliyor(true); setHata(null);
    try {
      if (data.laundryId) await apiRequest('laundry', 'PUT', data);
      else await apiRequest('laundry', 'POST', data);
      await veriYukle();
      setView('liste'); setSecili(null);
    } catch { setHata('Hata oluştu.'); }
    setKaydediliyor(false);
  }

  async function handleSil(id) {
    try { await apiRequest(`laundry/${id}`, 'DELETE'); setListe(p => p.filter(x => x.laundryId !== id)); setSilOnay(null); }
    catch (e) { alert(e?.message || 'Başarısız.'); }
  }

  const filtrelenmis = liste.filter(x => x.ad?.toLocaleLowerCase('tr-TR').includes(arama.toLocaleLowerCase('tr-TR')));
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn leading-none" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="🧺"
        iconColor="from-sky-500 to-blue-700"
        iconShadow="shadow-sky-200"
        title="Çamaşırhane"
        subtitle="Yıkama, ütüleme ve terzi hizmetleri fiyat listesi"
      >
        <button onClick={() => { setSecili(null); setView('ekle'); setHata(null); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-sky-500 to-blue-700 hover:from-sky-600 hover:to-blue-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-sky-100 transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden leading-none">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl leading-none">＋</span> <span className="relative leading-none">YENİ HİZMET EKLE</span>
        </button>
      </PageHeader>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 leading-none transform-gpu">
        {[
          { label: 'TOPLAM HİZMET', value: liste.length, icon: '🧺', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'YIKAMA GRUBU', value: liste.filter(x => x.grup === 'YIKAMA').length, icon: '💧', color: 'from-sky-500 to-sky-700 shadow-sky-100' },
          { label: 'KURU TEMİZLEME', value: liste.filter(x => x.grup === 'KURU TEMİZLEME').length, icon: '✨', color: 'from-blue-600 to-indigo-700 shadow-blue-100' },
          { label: 'PASİF / KAPALI', value: liste.filter(x => !x.aktifMi).length, icon: '⏸', color: 'from-rose-500 to-red-600 shadow-rose-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300 group`}>
             <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500 transform-gpu">{k.icon}</div>
             <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none text-left">{k.label}</p>
             <p className="text-xl md:text-2xl font-black tracking-tight leading-none text-left">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full text-left leading-none">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black leading-none">🔍</span>
            <input value={arama} onChange={e => setArama(e.target.value)} placeholder="Hizmet veya grup ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-sky-400 focus:outline-none bg-white transition-all shadow-sm font-bold leading-none" />
          </div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto leading-none whitespace-nowrap">Sistemde toplam <b className="text-sky-600 text-xs">{liste.length}</b> kayıt tanımlı</p>
        </div>

        {yukleniyor ? (
          <LoadingSpinner fullPage text="Listesi Hazırlanıyor..." />
        ) : (
          <>
            {/* Mobile Cards */}
            <div className="md:hidden divide-y divide-gray-50 leading-none">
              {filtrelenmis.length === 0 ? (
                <EmptyState icon="🧺" text="Eşleşen hizmet bulunamadı" />
              ) : filtrelenmis.map(item => (
                <div key={item.laundryId} className={`p-6 flex flex-col gap-5 hover:bg-sky-50/20 transition-all rounded-[2rem] group transform-gpu ${!item.aktifMi && 'grayscale opacity-60 bg-gray-100/30'}`}>
                  <div className="flex items-center justify-between gap-4 leading-none text-left">
                    <div className="flex items-center gap-5 min-w-0">
                      <div className="w-14 h-14 bg-white rounded-2xl shadow-xl shadow-sky-50 border border-gray-50 flex items-center justify-center text-2xl font-black text-sky-600 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 transform-gpu leading-none text-center">{item.ad[0]}</div>
                      <div className="min-w-0">
                        <p className="font-black text-gray-700 text-lg tracking-tight truncate leading-none mb-2 uppercase">{item.ad}</p>
                        <p className={`text-[9px] font-black px-2.5 py-1 rounded-lg border uppercase tracking-widest inline-block ${item.aktifMi ? 'bg-sky-50 text-sky-600 border-sky-100' : 'bg-gray-100 text-gray-400 border-gray-200'}`}>{item.grup || 'DİĞER'}</p>
                      </div>
                    </div>
                    <div className="text-right leading-none flex-shrink-0">
                       <span className="font-black text-sky-600 text-lg leading-none">{item.fiyat?.toFixed(2)} ₺</span>
                    </div>
                  </div>
                  <div className="flex gap-2 leading-none">
                    <EditButton size="lg" onClick={() => { setSecili(item); setView('duzenle'); setHata(null); }} />
                    <DeleteButton size="lg" onClick={() => setSilOnay(item.laundryId)} />
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto leading-none">
              <DataTable
                anahtarAlan="laundryId"
                satirlar={filtrelenmis}
                bosIkon="🧺"
                bosMetin="Kayıt bulunamadı"
                satirSinifi={item => !item.aktifMi ? 'grayscale-[0.8] opacity-60 bg-gray-50/50' : ''}
                kolonlar={[
                  {
                    anahtar: 'sira', baslik: '#', genislik: 'w-20',
                    ciz: (item, i) => <span className="font-black text-gray-300 text-xs">{i + 1}</span>,
                  },
                  {
                    anahtar: 'ad', baslik: 'Hizmet Detayı',
                    ciz: item => (
                      <span className="font-black text-gray-700 text-lg uppercase tracking-tight truncate">{item.ad}</span>
                    ),
                  },
                  {
                    anahtar: 'grup', baslik: 'Hizmet Grubu', hizala: 'orta', genislik: 'w-48',
                    ciz: item => (
                      <span className="text-[10px] font-black text-sky-600 bg-sky-50 px-4 py-2 rounded-xl uppercase tracking-widest border border-sky-100 inline-block">
                        {item.grup}
                      </span>
                    ),
                  },
                  {
                    anahtar: 'fiyat', baslik: 'Birim Fiyat', hizala: 'orta', genislik: 'w-40',
                    ciz: item => <span className="font-black text-gray-900 text-base">{item.fiyat?.toFixed(2)} ₺</span>,
                  },
                  {
                    anahtar: 'aktifMi', baslik: 'Durum', hizala: 'orta', genislik: 'w-40',
                    ciz: item => (
                      <div className={'inline-flex items-center px-4 py-2 rounded-2xl border ' +
                        (item.aktifMi ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-gray-100 text-gray-400 border-gray-200')}>
                        <span className="text-[10px] font-black uppercase tracking-widest">{item.aktifMi ? '✓ AKTİF' : '✗ PASİF'}</span>
                      </div>
                    ),
                  },
                  {
                    anahtar: 'islem', baslik: 'İşlemler', hizala: 'sag',
                    ciz: item => (
                      <ActionButtons
                        onEdit={() => { setSecili(item); setView('duzenle'); setHata(null); }}
                        onDelete={() => setSilOnay(item.laundryId)} />
                    ),
                  },
                ]}
              />
            </div>
          </>
        )}
      </div>

      <UsageInfo 
        color="cyan"
        description="Çamaşırhane modülü, misafirlerinizin kıyafetleri için sunulan yıkama, ütüleme ve terzi gibi hizmetlerin fiyatlandırılmasını yönetir."
        scenarios={[
          { title: "Misafir Harcamaları", content: "Müşterinin faturasına eklenen çamaşırhane hizmetleri, bu listedeki fiyatlar üzerinden doğrudan folyoya aktarılır." },
          { title: "Hizmet Gruplandırma", content: "Hizmetleri 'Yıkama' veya 'Kuru Temizleme' olarak gruplandırarak operasyonel cironuzu departman bazlı izleyebilirsiniz." },
          { title: "Fiyat Güncelleme", content: "Maliyet artışlarına göre birim fiyatları buradan güncellediğinizde, otel genelinde anlık olarak yeni fiyatlar geçerli olur." }
        ]}
      />

      {isOpen && createPortal(
        <LaundryFormModal 
          kayit={secili} 
          onKapat={() => { setView('liste'); setSecili(null); setHata(null); }} 
          onKaydet={handleKaydet}
          kaydediliyor={kaydediliyor}
          hata={hata}
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none font-black uppercase text-center">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm border border-gray-100 leading-none">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight leading-none uppercase">Hizmeti Sil</h3>
            <p className="text-[11px] font-black text-gray-400 mt-5 mb-10 leading-relaxed uppercase tracking-tight leading-loose italic">
               <b className="text-gray-900">"{liste.find(x => x.laundryId === silOnay)?.ad}"</b> kalıcı olarak silinecek. Emin misiniz?
            </p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95 leading-none">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-100 transition-all uppercase tracking-widest transform-gpu active:scale-95 leading-none font-black text-lg">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}